export default "__VITE_ASSET__23267210__"